<template>
<div class="content">
	<div class="container sell-your-tesla">
		<div class="row">
			<div class="col-sm-12" v-if="!submitted">
				<h1>Sell Your Tesla</h1>
				<p>List your car with Pre-Used EV for $79!</p>
				<form action="#" @submit="sellCar">
					<input type="text" v-model="email" placeholder="Email" required>
					<input type="text" v-model="vin" placeholder="VIN Number" required>
					<textarea v-model="description" placeholder="Description" required></textarea>
					<input type="submit" class="btn-primary" value="NEXT"/>
				</form>
			</div>
			<div class="col-sm-12" v-if="submitted">
				<h1>Success!</h1>
				<p>We will be in touch with next steps to get your car listed on Pre-Used EV</p>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import config from '@/config';
import { mapMutations } from 'vuex';
import _ from 'lodash';
import axios from 'axios';
export default {
	components: {
	},
	data() {
		return {
			vin: "",
			email: "",
			description: "",
			submitted: false,
			my_cars: []
		}
	},
	head() {
      return {
        title: "PRE-USED EV - Sell Your Tesla",
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: 'Sell your tesla on preusedev.com'
          }
        ]
	  }
    },
	methods: {
		sellCar(e){
			e.preventDefault();
			let formData = {
				action: "sell_car",
				vin: this.vin,
				email: this.email,
				description: this.description
			};
			console.log(formData);

			const encodeForm = (data) => {
				return Object.keys(data)
					.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
					.join('&');
			}

			var queryString = encodeForm(formData);

			return axios.post(config.API_URL+"?"+queryString, queryString, {headers: {"Authorization" : `Bearer ${this.$auth.strategy.token.get()}`}}).then(response => {
				if(response.data.status == true){
					this.submitted = true;
				}else{
					return null;
				}
			}, err_response => {
				console.log("Error submitting:", err_response);
			});
		}
	},
	watch: {
	},
	props: {
	},
	computed: {
	},
	mounted(){
		// var local = this;
		// local.getAlerts();
	},
	asyncData({ error, params, $axios }) {
		let formData = {
			action: "get_my_cars",
		};

		const encodeForm = (data) => {
			return Object.keys(data)
				.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
				.join('&');
		}

		return $axios.post(config.API_URL+"?"+encodeForm(formData), encodeForm(formData)).then(response => {
			if(response.data.status == true && response.data.data.length > 0){
				return { my_cars: response.data.data};
			}else{
				return { my_cars: null};
				// error({ statusCode: 404, message: 'Alerts not found' });
			}
		}, err_response => {
			console.log("Error getting alerts:", err_response);
		});
	}


}
</script>
<style lang="scss">

</style>
